/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// reactstrap components
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

function CardsHeader({ name, statistics, parentName }) {
  const [totalChecklistsOverall, setTotalChecklistsOverall] = React.useState(0);
  const [completedOnTimePercent, setCompletedOnTimePercent] = React.useState(0);
  const [notCompletedOnTimePercent, setNotCompletedOnTimePercent] = React.useState(0);
  const [notCompletedPercent, setNotCompletedPercent] = React.useState(0);

  React.useEffect(() => {
    const locations = Object.keys(statistics);
    let totalChecklists = 0;
    let completedOnTime = 0;
    let notCompletedOnTime = 0;
    let notCompleted = 0;

    if (locations.length > 0) {
      locations.forEach(location => {
        totalChecklists += statistics[location].totalChecklists === 0 ? 0.000001 : statistics[location].totalChecklists;
        completedOnTime += statistics[location].totalChecklists === 0 ? 0.000001 : statistics[location].onTime;
        notCompletedOnTime += statistics[location].totalChecklists === 0 ? 0.000001 : statistics[location].notOnTime;
        notCompleted += statistics[location].totalChecklists === 0 ? 0.000001 : statistics[location].notCompleted;
      })
    }

    setTotalChecklistsOverall(Math.round(totalChecklists));
    setCompletedOnTimePercent(locations.length === 0 ? '0%' : Math.round(completedOnTime * 100 / totalChecklists * 10) / 10 + '%');
    setNotCompletedOnTimePercent(locations.length === 0 ? '0%' : Math.round(notCompletedOnTime * 100 / totalChecklists * 10) / 10 + '%');
    setNotCompletedPercent(locations.length === 0 ? '0%' : Math.round(notCompleted * 100 / totalChecklists * 10) / 10 + '%');

  }, [name])
  return (
    <>
      <div className="header bg-info pb-6">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="6" xs="7">
                <h6 className="h2 text-white d-inline-block mb-0">{name}</h6>{" "}
              </Col>
            </Row>

            <Row>
              <Col md="6" xl="3">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Total Checklists
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {totalChecklistsOverall}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                          <i className="fas fa-th-list" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" xl="3">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          % Completed on time
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{completedOnTimePercent}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                          <i className="fas fa-check-circle" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" xl="3">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          % not on time
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{notCompletedOnTimePercent}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                          <i className="fas fa-clock" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" xl="3">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          % Not completed
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{notCompletedPercent}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                          <i className="fas fa-percent" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}

CardsHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string,
};

export default CardsHeader;
